var map = {
	"./act": 1572,
	"./act.ts": 1572,
	"./gmat": 1573,
	"./gmat.ts": 1573,
	"./gre": 1574,
	"./gre.ts": 1574,
	"./ielts": 1575,
	"./ielts.ts": 1575,
	"./ielts_general_training": 1576,
	"./ielts_general_training.ts": 1576,
	"./lsat": 1577,
	"./lsat.ts": 1577,
	"./mcat": 1578,
	"./mcat.ts": 1578,
	"./sat": 1579,
	"./sat.ts": 1579,
	"./toefl": 1580,
	"./toefl.ts": 1580
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2635;
module.exports = webpackAsyncContext;